export const editClientValidateInitial = {
    name: true,
    // type: boolean;
    representativeName: true,
    phone: true,
    addressDetail: true,
}